module.exports = __webpack_public_path__ + "52910c8d276e4b95c826f053cdeb71a4.svg";